import React from 'react'
import styled from 'styled-components'

import {
  makeTranslationAware
} from '../../../utils'
import {
  RawSelectableButton
} from './SelectableButton'

const StyledRawSelectableButton = styled(RawSelectableButton)`
  justify-content: start;
  padding-bottom: 0;
  padding-left: 4px;
  padding-right: 20px;
  padding-top: 0;
`

const Icon = styled.img`
  background-color: white;
  border-radius: 100%;
  display: inline-block;
  height: 3rem;
  margin: 12px;
  width: 3rem;
`

class RawSelectableIconButton extends React.PureComponent {
  render() {
    return (
      <StyledRawSelectableButton
        icon={ <Icon src={ this.props.iconUrl } /> }
        { ...this.props }
      />
    )
  }
}

const SelectableIconButton = makeTranslationAware(RawSelectableIconButton)

export { RawSelectableIconButton }
export default SelectableIconButton



// WEBPACK FOOTER //
// ./src/components/molecules/SelectableButton/SelectableIconButton.js